import { useQuery } from '@tanstack/react-query';
import { EmptyState, PageHeader } from '@/shared/components';
import { currentWorkspaceKeys, useApi, useApiProblem } from '@/shared/api';
import { WorkspaceSettingsForm } from './WorkspaceSettingsForm';
import { loadFailureMessage } from './workspaceSettingsModel';

/**
 * Stammdaten des eigenen Workspace: Name, Zeitzone, Währung und Kontaktadresse. Zeitzone und
 * Währung sind die Vorbelegung für neue Objekte; bestehende Objekte ändern sich nicht mit.
 */
export function WorkspaceSettingsPage() {
  const api = useApi();
  const settings = useQuery({
    queryKey: currentWorkspaceKeys.settings,
    queryFn: () => api.workspace.getSettings(),
  });
  const problem = useApiProblem(settings.error);

  return (
    <>
      <PageHeader
        eyebrow="Einstellungen"
        title="Stammdaten des"
        titleAccent="Workspace"
        description="Name, Zeitzone, Währung und Kontaktadresse dieses Workspace. Neue Objekte übernehmen Zeitzone und Währung, bestehende behalten ihre eigenen."
      />
      {settings.isLoading ? (
        <p className="text-ink-soft text-sm">Die Stammdaten werden geladen …</p>
      ) : settings.data ? (
        <WorkspaceSettingsForm settings={settings.data} />
      ) : (
        <EmptyState
          icon="Error"
          title="Die Stammdaten konnten nicht geladen werden"
          description={loadFailureMessage(problem)}
          action={{ label: 'Erneut laden', onClick: () => void settings.refetch() }}
        />
      )}
    </>
  );
}
